module.exports = __webpack_public_path__ + "static/quiz_boy-a10f69c3c75a0bbdc48337e091f61ec1.svg";